import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ChefHat } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

/**
 * Route guard: redirects to /login when the user is not authenticated.
 * Shows a small loading state while AuthContext resolves /api/auth/me.
 */
export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useLang();

  if (loading) {
    return (
      <div className="min-h-[80vh] flex flex-col items-center justify-center" data-testid="auth-loading">
        <div className="relative">
          <div className="absolute inset-0 rounded-3xl bg-[#C05A42]/20 blur-2xl animate-pulse" />
          <div className="relative inline-flex h-16 w-16 items-center justify-center rounded-3xl bg-[#C05A42] text-white">
            <ChefHat className="h-8 w-8" />
          </div>
        </div>
        <p className="mt-4 text-sm text-[#5C4D44] dark:text-neutral-400">{t('appName')}</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
